import consentManagementModule from './consentManagement';
import priceFloorsModule from './priceFloors';
import {applyPlaceholders} from '../../utils/placeholder';
import storage from '../../utils/storage';
import {getRandomizedUserId, getUserId} from "../../services/userService";

function _getPlaceholders() {
	return {
		'PWID': storage.getFromCookie('authId'),
		'domain': window.location.hostname,
		'userId': getUserId(),
		'randomizedUserId': getRandomizedUserId()
	};
}

export function getModuleConfig(config: PrebidConfig) {
	const prebidModuleConfig: AnyObject = JSON.parse(JSON.stringify(config.additionalConfig ?? {}));

	consentManagementModule.apply(prebidModuleConfig, config);
	priceFloorsModule.apply(prebidModuleConfig);

	return applyPlaceholders(prebidModuleConfig, _getPlaceholders()) as AnyObject;
}

type BidderConfig = {
	bidders: Array<string>
	config: AnyObject
};

export function getBidderModuleConfigs(config: PrebidConfig) {
	const additionalBidderConfigs = JSON.parse(JSON.stringify(config.additionalBidderConfigs ?? [])),
		placeholders = _getPlaceholders();

	return additionalBidderConfigs.map((bidderConfig: BidderConfig) => {
		return applyPlaceholders(bidderConfig, placeholders) as BidderConfig;
	});
}

export default {
	getModuleConfig,
	getBidderModuleConfigs
};
